import FilterSelectInput from './FilterSelectInput'

export default FilterSelectInput
